const RANGOS = [
	"Hierro",
	"Bronce",
	"Plata",
	"Oro",
	"Platino",
	"Diamante",
	"Inmortal"
];

export const calcularRanked =
({
	lpActual,
	rangoActual,
	resultado
}) => {

	let lp = lpActual;

	if (resultado === true) {

		lp += 18;

	} else if (resultado === false) {

		lp -= 12;
	}

	lp = Math.max(0, lp);

	let rangoIndex =
		RANGOS.indexOf(rangoActual);

	// ASCENSO

	if (lp >= 100) {

		lp = 0;

		rangoIndex = Math.min(
			rangoIndex + 1,
			RANGOS.length - 1
		);
	}

	// DESCENSO

	if (
		lp <= 0 &&
		resultado === false &&
		rangoIndex > 0
	) {

		rangoIndex -= 1;

		lp = 70;
	}

	return {
		lp,
		rango:
			RANGOS[rangoIndex]
	};
};